export default __webpack_public_path__ + "static/media/volume-zero-icon.91e2089e.svg";